// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsSplitWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SplitGetTreatmentResponseDto } from '../..';

interface GetTreatmentParams {
  featureName: string;
}

export const CappsSplitWebApiHandler_getTreatment_Path = '/api/web/renter/v1/split/getTreatment';

export const CappsSplitWebApiHandler_getTreatment = (getParams: GetTreatmentParams, client = getClient()) => {
  return httpFrontEndRequest<GetTreatmentParams, never, SplitGetTreatmentResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsSplitWebApiHandler_getTreatment_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
